import { Clock } from "lucide-react";

import { CockpitLabels } from "@/lib/labels";
import { cn } from "@/lib/utils";

const AMBER_THRESHOLD = 4;

export function WindowChip({ open, hoursLeft }: { open: boolean; hoursLeft: number | null }) {
	const amber = open && hoursLeft !== null && hoursLeft <= AMBER_THRESHOLD;

	return (
		<span
			data-slot="window-chip"
			data-open={open}
			className={cn(
				"inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium leading-none",
				!open && "border-border bg-border/40 text-muted-foreground",
				open && !amber && "border-info/30 bg-info/10 text-info",
				amber && "border-warning/40 bg-warning/10 text-warning",
			)}
		>
			<Clock className="size-3" />
			{CockpitLabels.window(open, hoursLeft)}
		</span>
	);
}
